import React from "react";
import Tooltip from "Components/tooltip/Tooltip";
import { Icon, refresh } from "Icons/index";
import DeliveryDomainStatusLabel from "Components/deliveryStatusLabel/DeliveryDomainStatusLabel";
import cx from "classnames";
import t from "Utils/translation";
import s from "./deliveryDomainStatusBadge.scss";

const deriveStatus = (domain) => {
  const i18n_key = "delivery.domains.status";

  if (!domain.status && domain.status_detail === "customer") {
    return { msg: t(`${i18n_key}.disabled_by_customer`), color: "yellow" };
  }

  if (!domain.status && domain.status_detail === "admin") {
    return { msg: t(`${i18n_key}.disabled_by_admin`), color: "yellow" };
  }

  const dns_verified = domain.dns_verification_status === "verified";
  const is_approved = domain.approval_status === "approved";

  if (!domain.status && !dns_verified && !is_approved) {
    return { msg: t(`${i18n_key}.not_verified`), color: "yellow" };
  }

  if (!domain.status && dns_verified && !is_approved && domain.approval_status !== "pending") {
    return { msg: t(`${i18n_key}.need_approval`), color: "yellow" };
  }

  if (!domain.status && dns_verified && domain.approval_status === "pending") {
    return { msg: t(`${i18n_key}.pending_approval`), color: "blue", loading: true };
  }

  if (domain.status && !dns_verified) {
    return { msg: t(`${i18n_key}.approved_dns`), color: "green", alert: true };
  }

  if (domain.status && dns_verified) {
    return { msg: t(`${i18n_key}.approved`), color: "green", alert: false };
  }

  return {};
};

export default function DeliveryDomainStatusBadge({ domain, textOnly, asLabel }) {
  const status = deriveStatus(domain);

  if (textOnly) return status.msg;

  if (asLabel) {
    return <DeliveryDomainStatusLabel domain={domain} className="ml-3" />;
  }

  return (
    <div className={s.wrapBadge}>
      <Tooltip text={status.msg}>
        <div
          className={cx(s.badge, {
            [s[status.color]]: true,
            [s.alert]: status.alert,
          })}
        >
          {status.loading ? <Icon className={s.syncIcon} svg={refresh} width={"0.75rem"} height={"0.75rem"} /> : ""}
        </div>
      </Tooltip>
    </div>
  );
}
